/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Policy_LateInputs */

const en_price_page_policy_late = /** @type {(inputs: Price_Page_Policy_LateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After that, part of the price stays with the specialist`)
};

const pl_price_page_policy_late = /** @type {(inputs: Price_Page_Policy_LateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Później część ceny zostaje u specjalisty`)
};

/**
* | output |
* | --- |
* | "After that, part of the price stays with the specialist" |
*
* @param {Price_Page_Policy_LateInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_policy_late = /** @type {((inputs?: Price_Page_Policy_LateInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Policy_LateInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_policy_late(inputs)
	return en_price_page_policy_late(inputs)
});